import { getTradedPositions, getPortfolioWorkingEquity } from "./index"
import { chain, capitalize } from "lodash"
import { createSelector } from "reselect"
import { getViewType, getPortfolioName, getIsActive } from "modules/portfolio-root/selectors/portfolios"
import { getExcelValue } from "helpers/csv"
import { getTradeExportCsvHeaders, TRADE_TYPES_ORDER } from "helpers/trade-export-csv-headers"

const getDate = (state, props) => props.on

export const getFileName = createSelector(
  [getPortfolioName, getViewType, getDate],
  (portfolioName, viewType, date) => `${portfolioName} Experiment Trades ${capitalize(viewType.substr(0, 3))} ${date}`,
)

export const getCsvRows = createSelector(
  [getTradedPositions, getPortfolioWorkingEquity, getIsActive],
  (trades, workingEquity, isActiveView) => ([
    getTradeExportCsvHeaders(isActiveView),
    ...chain(trades)
      .sortBy([({ tradeType }) => TRADE_TYPES_ORDER[tradeType], "ticker"])
      .map(({ tradeType, ticker, mic, country, assetClass, classification, currency, securityPercentEquity, tradePercentDelta, experimentSize }) => ([
        tradeType,
        ticker,
        mic,
        country,
        assetClass,
        currency,
        classification,
        getExcelValue(securityPercentEquity * workingEquity),
        getExcelValue(experimentSize),
        getExcelValue(experimentSize - (securityPercentEquity * workingEquity)),
        getExcelValue(securityPercentEquity, { percent: true }),
        getExcelValue((experimentSize / workingEquity), { percent: true }),
        getExcelValue(tradePercentDelta, { percent: true }),
      ]))
      .value(),
  ]),
)
